import style from "./index.module.css";

const Highlights = ({ highlights }: ComponentPropsType) => {
  return (
    <div className={`${style.all_highlights} row`}>
      {highlights.map((highlight) => (
        <div
          key={highlight.id}
          className={`${style.single_highlight} col-md-2 col-sm-3 col-4`}
        >
          <img src={highlight.icon} alt="" />
          <span>{highlight.name}</span>
          <p>{highlight.label||highlight.value}</p>
        </div>
      ))}
    </div>
  );
};

export default Highlights;

export type HighlightsType = {
  id: number;
  icon: string;
  name: string;
  value: string;
  label: string | undefined;
};

type ComponentPropsType = {
  highlights: HighlightsType[];
};
